import { buildHtml , ContentRoute,RouteSlotInput  } from '@caritas/ui';

import {isDefined} from "../../utils/is-defined";
import { mapImage } from '../Image.mappers';

export function mapContactBoxBlock(
  input: BlockContactBoxFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'contactBox'> {
  return {
    key: 'contactBox',
    input: () => [
      {
        contacts: input.contacts?.filter(isDefined).map(({ contact }) => {
          const addressLines = [];
          if (contact?.address?.address1) {
            addressLines.push(contact.address?.address1);
          }
          if (contact?.address?.address2) {
            addressLines.push(contact?.address?.address2);
          }

          // if postal code is added, output postal code, city and country as follows:
          // CH-6002 Luzern
          // (country code derived from country; do not additionally output country)
          //
          // if postal code is NOT added, output city and country as follows:
          // Luzern, Schweiz
          // Handle different variations of city address line
          if (
            contact?.address?.zipcode &&
            contact.address?.city &&
            contact.address.countryCode
          ) {
            addressLines.push(
              `${contact.address.countryCode}-${contact.address?.zipcode} ${contact.address?.city}`,
            );
          } else if (
            !contact?.address?.zipcode &&
            contact?.address?.city &&
            contact?.address.country
          ) {
            addressLines.push(
              `${contact.address.city}, ${contact.address.country}`,
            );
          } else if (
            !contact?.address?.zipcode &&
            !contact?.address?.city &&
            contact?.address?.country
          ) {
            addressLines.push(contact.address.country);
          }
          return {
            name: contact?.name,
            role: contact?.role,
            organisation: contact?.organisation,
            Address:
              addressLines.length > 0
                ? buildHtml(addressLines.join('<br />'))
                : undefined,
            telephone: contact?.phone,
            mail: contact?.mail,
            AdditionalInfo: buildHtml(contact?.additionalInfo || ''),
            Image:
              contact?.image?.image &&
              mapImage({
                image: contact.image.image,
                preset: 'contact_box',
                caption: contact.image?.caption,
              }),
          };
        }) || [],
      },
      200,
    ],
  };
}
